import { useCallback } from "react";
import { store } from "@redux";

interface IProps {
  to: string;
  children: React.ReactNode;
}

export const HasAccess = ({ to, children }: IProps) => {
  return !!store.getState().permission.actions.includes(to) ? (
    <>{children}</>
  ) : null;
};

export const useAccessCtrl = () => {
  const Actions = store.getState().permission.actions;

  const handleAccessTo = useCallback(
    (to: string) => {
      return !!Actions.includes(to);
    },
    [Actions]
  );

  return {
    handleAccessTo,
  };
};

export const hasAccess = (to: string): boolean => {
  const Actions = store.getState().permission.actions;
  return !!Actions.includes(to);
};
